export const CARROSSEL_LIST = "CARROSSEL_LIST";
export const CARROSSEL_GET = "CARROSSEL_GET";
export const CARROSSEL_CREATE = "CARROSSEL_CREATE";
export const CARROSSEL_DELETE = "CARROSSEL_DELETE";
export const CARROSSEL_UPDATE = "CARROSSEL_UPDATE";
export const CARROSSEL_UPDATE_IMAGE = "CARROSSEL_UPDATE_IMAGE";
export const CARROSSEL_DELETE_SLIDE = "CARROSSEL_DELETE_SLIDE";
export const CARROSSEL_DUPLICATE = "CARROSSEL_DUPLICATE";
